import React, { memo, useCallback } from "react";
import { Menu, Item, Separator, Submenu, useContextMenu } from "react-contexify";
import IconMC from "./IconMC";
import TooltipMC from "./TooltipMC";

// Componente auxiliar para renderizar icono y label con estilos (memorizado)
const MenuItemLabel = memo(({ icon, iconClassName, label, showLock = false }) => (
  <span className="tw-flex tw-items-center tw-gap-1">
    {icon && (
      <span className={`tw-mr-1 ${iconClassName || "tw-text-gray-500"}`}>
        <IconMC name={icon} size="base" />
      </span>
    )}
    <span className="tw-break-words tw-whitespace-normal tw-max-w-[220px]">{label}</span>
    {showLock && (
      <span className="tw-text-gray-400 tw-flex-shrink-0">
        <IconMC name="lock-outline" size="sm" />
      </span>
    )}
  </span>
));

// ContextMenuWrapperMC.jsx
const ContextMenuWrapperMC = memo(({ id, menuItems = [], onItemClick, children }) => {
  const { show } = useContextMenu({ id });

  // Mostrar menú al hacer clic derecho
  const handleContextMenu = (e) => {
    e.preventDefault();
    show({ event: e });
  };

  // Renderiza ítems dinámicamente (memorizado)
  const renderMenuItems = useCallback((items) =>
    items.map((item, idx) => {
      if (item.separator) return <Separator key={idx} className="my-1" />;

      if (item.subItems)
        return (
          <Submenu
            key={item.key || idx}
            disabled={item.disabled}
            label={
              item.disabledTitle ? (
                <TooltipMC text={item.disabledTitle} position="left" className="tw-inline-flex">
                  <MenuItemLabel
                    icon={item.icon}
                    iconClassName={item.iconClassName}
                    label={item.label}
                    showLock={item.disabled}
                  />
                </TooltipMC>
              ) : (
                <MenuItemLabel
                  icon={item.icon}
                  iconClassName={item.iconClassName}
                  label={item.label}
                  showLock={item.disabled}
                />
              )
            }
          >
            <div className="tw-max-h-[300px] tw-overflow-y-auto">
              {renderMenuItems(item.subItems)}
            </div>
          </Submenu>
        );

      return (
        <Item
          key={item.key || idx}
          disabled={item.disabled}
          onClick={() => {
            if (item.disabled) return;
            item.onClick?.(item.key || item.id || idx);
            onItemClick?.(item);
          }}
          className={`${item.className || ''} ${item.disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''}`}
        >
          {item.disabledTitle ? (
            <TooltipMC text={item.disabledTitle} position="left" className="tw-inline-flex">
              <MenuItemLabel
                icon={item.icon}
                iconClassName={item.iconClassName}
                label={item.label}
                showLock={item.disabled}
              />
            </TooltipMC>
          ) : (
            <MenuItemLabel
              icon={item.icon}
              iconClassName={item.iconClassName}
              label={item.label}
              showLock={item.disabled}
            />
          )}
        </Item>
      );
    })
  , [onItemClick]);

  return (
    <div onContextMenu={handleContextMenu} className="tw-w-full">
      {children}
      <Menu id={id}>
        {renderMenuItems(menuItems)}
      </Menu>
    </div>
  );
});

ContextMenuWrapperMC.displayName = "ContextMenuWrapperMC";

export default ContextMenuWrapperMC;
